
import {
  WorkbenchDto,
  CreateWorkbenchDto,
  UpdateWorkbenchDto,
  UpsertWorkbenchGeneratorInstanceDto,
  SubmittedUpsertWorkbenchGeneratorInstanceDto
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { axios, PaginatedQueryBase } from './api'

export type WorkbenchFilters = PaginatedQueryBase & {
  includeInactive: boolean
}

class WorkbenchService extends BaseCrudService<
  WorkbenchDto,
  CreateWorkbenchDto,
  UpdateWorkbenchDto,
  WorkbenchFilters
> {
  constructor() {
    super('workbench', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }

  upsertGeneratorInstance(id: string, generatorSlotId: string, dto: SubmittedUpsertWorkbenchGeneratorInstanceDto): Promise<WorkbenchDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig(
        'post',
        `${this.endpoint}/${id}/generator-instance/${generatorSlotId}`,
        dto
      )
      axios(configs, resolve, reject)
    })
  }

  removeGeneratorInstance(id: string, generatorSlotId: string): Promise<WorkbenchDto> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig(
        'delete',
        `${this.endpoint}/${id}/generator-instance/${generatorSlotId}`
      )
      axios(configs, resolve, reject)
    })
  }
}

export const workbenchService = new WorkbenchService()
